<template>
	<div>
		<div class="row">
			<div class="col-12 mb-4">
				<h1 v-if="isNew">{{ $t("add-template") }}</h1>
				<h1 class="float-left" v-else-if="loaded">{{ template.tttemplate_name }}</h1>
				<div class="skeleton midnight h16 w-half" v-else></div>

				<button class="btn btn-primary float-right" @click="finishEditing" v-if="editing">
					{{ $t("save") }}
				</button>
				<button class="btn btn-primary float-right" @click="startEditing" v-else>
					{{ $t("edit") }}
				</button>
			</div>

			<div class="col-12" v-if="success">
				<b-alert variant="success" show>
					{{ $t("template-added-successfully") }}
				</b-alert>
			</div>

			<div class="row" v-if="error">
				<div class="col-12">
					<b-alert variant="danger" show>{{ error }}</b-alert>
				</div>
			</div>

			<div class="col-12 mb-4">
				<label class="font-bold">{{ $t("template-name") }}</label>
				<b-form-input v-model="newName" v-if="editing" />
				<p class="mb-0" v-else-if="loaded">{{ template.tttemplate_name }}</p>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>

			<div class="col-12 mb-4">
				<label class="font-bold">{{ $t("start-time") }}</label>
				<b-form-timepicker
					v-model="newStartTime"
					locale="en"
					v-if="editing"
				></b-form-timepicker>
				<p class="mb-0" v-else-if="loaded">{{ formattedTimeFrom }}</p>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>

			<div class="col-12 mb-4">
				<label class="font-bold">{{ $t("end-time") }}</label>
				<b-form-timepicker
					v-model="newEndTime"
					locale="en"
					v-if="editing"
				></b-form-timepicker>
				<p class="mb-0" v-else-if="loaded">{{ formattedTimeTo }}</p>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			template: {},
			loaded: false,
			editing: false,
			newName: "",
			newStartTime: null,
			newEndTime: null,
			error: null,
			success: false,
		};
	},
	mounted() {
		if (this.isNew) {
			this.loaded = true;
			this.editing = true;
		} else {
			this.getTemplate();
		}
	},
	methods: {
		extractTime: function (timeStr) {
			return timeStr.split(" ")[1];
		},
		getTemplate: function () {
			this.$cfetch(
				`${this.$settings.APIBaseURL}/timetable/tttemplate/get?tttemplate_id=${this.$route.params["templateid"]}`
			)
				.then((json) => {
					console.log("get json", json);
					if (json.status === "SUCCESS") {
						this.template = json.result;
						this.loaded = true;
					}
				})
				.catch((err) => console.error(err));
		},
		startEditing: function () {
			this.editing = true;
			this.newName = this.template.tttemplate_name;
			this.newStartTime = this.extractTime(this.template.tttemplate_timefrom);
			this.newEndTime = this.extractTime(this.template.tttemplate_timeto);
		},
		finishEditing: function () {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/tttemplate/save`, {
				method: "post",
				data: this.dataObj,
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.editing = false;
					this.template = res.result;
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = "Unable to save template";
					}
				}
			});
		},
	},
	computed: {
		isNew: function () {
			return !this.$route.params["templateid"];
		},
		dataObj: function () {
			if (this.isNew) {
				return {
					tttemplate_name: this.newName,
					tttemplate_timefrom: this.newStartTime,
					tttemplate_timeto: this.newEndTime,
				};
			} else {
				return {
					tttemplate_id: this.$route.params["templateid"],
					tttemplate_name: this.newName,
					tttemplate_timefrom: this.newStartTime,
					tttemplate_timeto: this.newEndTime,
				};
			}
		},
		formattedTimeFrom: function () {
			return this.template.tttemplate_timefrom.split(" ")[1];
		},
		formattedTimeTo: function () {
			return this.template.tttemplate_timeto.split(" ")[1];
		},
	},
};
</script>
